import React , { Component } from 'react';
import { Row, Col, Card, Button, Select, DatePicker } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import RequirementTable from'./RequirementTable';
import './page-requirement.less';
import ErrorBoundary from 'antd/lib/alert/ErrorBoundary';
import SearchSelectComponent, { SearchSelectOption } from '../../components/public/SearchSelectComponent';
import CompanyService, { CompanyListRequest, ICompanyInfoList } from '../../service/company/CompanyService';
import RequeirementStatesSelect from '../../components/public/RequeirementStatesSelect';
import RequirementService, { IRequirementSalesOption } from '../../service/requirement/RequirementService';

interface RequirementPageProps extends RouteComponentProps {
}

interface RequirementPageState {
    salesSelectValue: number | null,
    companySelectValue: number | null,
    statesSelectValue: number | number[] | null,
    beginTimeValue: string | null,
    endTimeValue: string | null,
    showAlert :boolean,
    alertMessage: string,
    isAssignModalVisible: boolean,
    assignSalesValue: number | null,
    isImportModalVisible: boolean,
    salesList: IRequirementSalesOption[],
    companyMappedInfo: SearchSelectOption[],
}

const STORAGE_KEYS = {
    MY_REQUIREMENT_PAGE: 'myRequirementCurrentPage',
    REQUIREMENT_PAGE: 'requirementCurrentPage'
};


//define RequirementPage class
class RequirementPage extends Component<RequirementPageProps, RequirementPageState> {
    state = {
        salesSelectValue: null,
        companySelectValue: null,
        statesSelectValue: null,
        beginTimeValue: null,
        endTimeValue: null,
        showAlert: false,
        alertMessage: '',
        salesList: [],
        isAssignModalVisible: false,
        assignSalesValue: null,
        isImportModalVisible: false,
        companyMappedInfo: [],
    };

    async componentDidMount() {
        window.addEventListener('popstate', this.handlePopState);
        this.getRequirementDataBasedOnEntry();

        const storageKey = this.getPageStorageKey();
        const currentPage = parseInt(localStorage.getItem(storageKey) || '1', 10);
        if (this.requirementTableRef) {
            this.requirementTableRef.setPaginationPage(currentPage);
        }
        if (!this.isMyRequirementPage()) {
            this.getSalesListInfo();
        }
        //获取所有公司信息，用于展示公司下拉选择框内容
        const request: CompanyListRequest = {
            companyQueryParam: {
            },
            pageNo: 1,
            pageSize: 9999999,
        };
        const response = await CompanyService.getCompanyListInfo(request);
            if (response) {
            const pageData: ICompanyInfoList = response.data && response.data.companyInfoList ? response.data.companyInfoList : [];
            const CompanyRecords = pageData && pageData.records ? response.data.companyInfoList.records : [];
            const companyMappedInfo = CompanyRecords.map((item: any) => ({
                key: item.id,
                value: item.name,
            }));
            this.setState({ companyMappedInfo: companyMappedInfo});
        }
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.handlePopState);
    }

    // 获取当前页面对应的 localStorage key
    getPageStorageKey = () => {
        return this.isMyRequirementPage() ? STORAGE_KEYS.MY_REQUIREMENT_PAGE : STORAGE_KEYS.REQUIREMENT_PAGE;
    };
    
    isMyRequirementPage = () => {
        return this.props.location.pathname === '/app/my/requirement/list';
    };

    getPageTitle = () => {
        return this.isMyRequirementPage() ? '我的需求列表' : '客户需求列表';
    };

    getBreadcrumbs = () => {
        return this.isMyRequirementPage() 
            ? ['我的', '我的需求列表']
            : ['需求沟通信息', '客户需求列表'];
    };
    
    //监听浏览器返回事件
    handlePopState = () => {
        sessionStorage.setItem('isBackNavigation', 'true');
    };

    //确定进入方式，并获取数据
    getRequirementDataBasedOnEntry = () => {
        const isBack = sessionStorage.getItem('isBackNavigation') === 'true';
        const storageKey = this.getPageStorageKey();
        const pageNo = isBack ? parseInt(localStorage.getItem(storageKey) || '1', 10) : 1;
    
        // 更新 localStorage
        localStorage.setItem(storageKey, pageNo.toString());
        sessionStorage.removeItem('isBackNavigation');
    
        if (!isBack) {
            // 通知 RequirementTable 重置分页
            if (this.requirementTableRef) {
                this.requirementTableRef.setPaginationPage(1);
            }
        }
        // 让 RequirementTable 组件加载数据
        this.requirementTableRef.getRequirementTableData(
            pageNo, 
            this.state.companySelectValue,
            this.state.salesSelectValue,
            this.state.beginTimeValue,
            this.state.endTimeValue,
            this.state.statesSelectValue
        );
    };

    requirementTableRef: RequirementTable;

    // 获取销售列表
    getSalesListInfo = async () => {
        try {
            const response = await RequirementService.getRequirementSalesOptions();
            if (response && response.data && response.data.salesOptionList) {
                this.setState({ salesList: response.data.salesOptionList });
            } else {
                this.setState({ salesList: [] });
                console.warn('获取销售列表数据为空');
            }
        } catch (error) {
            this.setState({ salesList: [] });
            console.error('获取销售列表失败:', error);
        }
    };

    //公司选择框处理
    CompanySelect = () => {
        const handleCompanySelectChange = (key: number | null, value: string | null) => {
            this.setState({ companySelectValue: key }, () => {
                // 状态更新后重新加载数据
                if (this.requirementTableRef) {
                    this.requirementTableRef.getRequirementTableData(
                        1,
                        this.state.companySelectValue,
                        this.state.salesSelectValue,
                        this.state.beginTimeValue,
                        this.state.endTimeValue,
                        this.state.statesSelectValue,
                    );
                    this.requirementTableRef.setPaginationPage(1);
                }
            });
        };
     
        const handleClear = () => {
            this.setState({ companySelectValue: null }, () => {
                // 状态更新后重新加载数据
                if (this.requirementTableRef) {
                    this.requirementTableRef.getRequirementTableData(
                        1,
                        this.state.companySelectValue,
                        this.state.salesSelectValue,
                        this.state.beginTimeValue,
                        this.state.endTimeValue,
                        this.state.statesSelectValue,
                    );
                    this.requirementTableRef.setPaginationPage(1);
                }
            });
        };   
    
        return (
            <>
                <label className="label-requirement_company">公司名：</label>
                <SearchSelectComponent 
                    className="select-requirement_company"
                    placeholder="请选择客户公司名"
                    optionProps={this.state.companyMappedInfo} 
                    initialValues={this.state.companySelectValue}
                    onChange={handleCompanySelectChange}
                    onClear={handleClear}
                    disabled={false} 
                    allowClear
                />
            </>
        );
    };

    //销售选择框处理
    SalesSelect = () => {
        return (
            <>
                <label className="label-requirement_sales">销售：</label>
                <Select 
                    className="select-requirement_sales"
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        ((option && option.props && option.props.children) ? String(option.props.children) : '')
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                    onChange={(value) => {
                        this.setState({ 
                            salesSelectValue: value !== undefined && value !== null ? value : null
                        }, () => {
                            // 状态更新后重新加载数据
                            this.requirementTableRef.getRequirementTableData(
                                1,
                                this.state.companySelectValue,
                                this.state.salesSelectValue,
                                this.state.beginTimeValue,
                                this.state.endTimeValue,
                                this.state.statesSelectValue,
                            );
                        });
                        if (this.requirementTableRef) {
                            this.requirementTableRef.setPaginationPage(1);
                        }
                    }}
                    value={this.state.salesSelectValue !== null ? this.state.salesSelectValue : undefined}
                    allowClear
                    placeholder="请选择"
                >
                    {this.state.salesList && this.state.salesList.map(item => (
                        <Select.Option key={item.id} value={item.id}>
                            {item.name}
                        </Select.Option>
                    ))}
                </Select>
            </>
        );
    };

    //需求状态选择控件处理
    StatesSelect = () =>{
        return (
            <>
                <label className="label-requirement_states">需求状态：</label>
                <RequeirementStatesSelect 
                    showAllOption 
                    onChange={(value) => {this.setState({ statesSelectValue: value });}}
                    mode="multiple"
                />
            </>
        );
    }

    //需求更新时间选择处理（与项目列表同款控件）
    RequirementTimePick = () => {
        return (
            <>
                <label className="label-requirement_time">需求更新时间：</label>
                <DatePicker.RangePicker
                    className="picker-requirement_time"
                    allowEmpty={[true, true]}
                    format="YYYY-MM-DD"
                    onChange={(values) => {
                        this.setState({
                            beginTimeValue: values && values[0] ? values[0].startOf('day').format('YYYY-MM-DD') : null,
                            endTimeValue: values && values[1] ? values[1].endOf('day').format('YYYY-MM-DD') : null,
                        });
                    }}
                />
            </>
        );
    };

    //查询按钮点击事件
    handleQueryButtonClick = async () => {
        await this.requirementTableRef.getRequirementTableData(
            1,
            this.state.companySelectValue,
            this.state.salesSelectValue,
            this.state.beginTimeValue,
            this.state.endTimeValue,
            this.state.statesSelectValue,
        );
        if (this.requirementTableRef) {
            this.requirementTableRef.setPaginationPage(1);
        }
    };

    render() {
        return (
            <ErrorBoundary>
                <div className="gutter-requirement_table">
                    <BreadcrumbCustom breads={this.getBreadcrumbs()} />
                    <Row gutter={5}>
                        <Col className="gutter-requirement_row" md={25}>
                            <div className="gutter-requirement_box">
                                <Card title={<div className="title-list_page">{this.getPageTitle()}</div>} bordered={false}>
                                    <div className="requirement-filter-container">
                                        {this.isMyRequirementPage() ? (
                                            <div className="requirement-filter-row">
                                                <div className="requirement-filter-item requirement-filter-item-long">
                                                    <this.CompanySelect />
                                                </div>
                                                <div className="requirement-filter-item requirement-filter-item-short">
                                                    <this.StatesSelect />
                                                </div>
                                                <div className="requirement-filter-item requirement-filter-item-long">
                                                    <this.RequirementTimePick />
                                                </div>
                                                <div className="requirement-filter-actions">
                                                    <Button className="button-requirement_query" type="primary" onClick={this.handleQueryButtonClick}>
                                                        查询
                                                    </Button>
                                                </div>
                                            </div>
                                        ) : (
                                            <>
                                                <div className="requirement-filter-row">
                                                    <div className="requirement-filter-item requirement-filter-item-short">
                                                        <this.SalesSelect />
                                                    </div>
                                                    <div className="requirement-filter-item requirement-filter-item-long">
                                                        <this.CompanySelect />
                                                    </div>
                                                </div>
                                                <div className="requirement-filter-row">
                                                    <div className="requirement-filter-item requirement-filter-item-short">
                                                        <this.StatesSelect />
                                                    </div>
                                                    <div className="requirement-filter-item requirement-filter-item-long">
                                                        <this.RequirementTimePick />
                                                    </div>
                                                    <div className="requirement-filter-actions">
                                                        <Button className="button-requirement_query" type="primary" onClick={this.handleQueryButtonClick}>
                                                            查询
                                                        </Button>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    <div className="requirement-table-wrapper">
                                    <RequirementTable
                                        ref={(ref) => (this.requirementTableRef = ref)}
                                        companyId={this.state.companySelectValue}
                                        salesId={this.state.salesSelectValue}
                                        states={this.state.statesSelectValue}
                                        beginTime={this.state.beginTimeValue}
                                        endTime={this.state.endTimeValue}
                                        isMyRequirementPage={this.isMyRequirementPage()}
                                    />
                                    </div>
                                </Card>
                            </div>
                        </Col>
                    </Row>

                </div>
            </ErrorBoundary>
        );
        
    }
}

export default withRouter(RequirementPage);
